import { useEffect, useMemo } from 'react'
import { useGLTF } from '@react-three/drei'
import { useTrackController } from './useTrackController'
import { createBorderGeo } from './borderMeshBuilder'
import { BorderVisibilityController } from './BorderVisibilityController'
import { gltfAsset } from '../../assetStore'
import { applyMaterial, useAtlasMaterial } from '../../materials/atlasMaterial'
import { disposeObject } from '../../../utils/threeDisposal'

export function BorderTrack() {
    const { scene: border1Scene } = useGLTF(gltfAsset.Border_LVL_01)
    const { scene: border2Scene } = useGLTF(gltfAsset.Border_LVL_02)
    const { scene: border3Scene } = useGLTF(gltfAsset.Border_LVL_03)
    const { scene: border4Scene } = useGLTF(gltfAsset.Border_LVL_04)
    const trackController = useTrackController()
    const atlasMaterial = useAtlasMaterial()

    const borderGeo = useMemo(
        () => createBorderGeo(
            {
                1: applyMaterial(border1Scene, atlasMaterial),
                2: border2Scene,
                3: applyMaterial(border3Scene, atlasMaterial),
                4: border4Scene,
            },
            trackController,
        ),
        [
            border1Scene,
            border2Scene,
            border3Scene,
            border4Scene,
            atlasMaterial,
            trackController,
        ],
    )
    useEffect(() => {
        return () => {
            disposeObject(borderGeo)
        }
    }, [borderGeo])

    return (
        <>
            <primitive object={borderGeo} />
            <BorderVisibilityController borderGeo={borderGeo} />
        </>
    )
}
